export * from './_constants'
export * from './_hooks'
export * from './_types'
export * from './_utils'

export {
  FUEL_DOMAIN_TO_API,
  mapSummaryToDetail,
} from './_apis/mapSummaryToDetail'

export type {
  IDashboardSummaryResponse,
  TApiFuelType,
} from './_apis/getModooGarageSummary'
export type { IModoocarQuery, IModoocarDetailResult } from './_apis'

// [주의]: serverHttp를 쓰는 getModoocarDetail 등은 배럴에 넣지 않습니다. 넣으면 클라이언트 빌드가 깨집니다.
// 서버 컴포넌트에서 './_features/modoocar/_apis'를 직접 import 합니다.
